import {useEffect, useEffectEvent} from 'react';

/**
 * Calls `onCancel` when Escape is pressed with focus inside a drag context, while `isEnabled`.
 * Use it for a selection that is no longer being dragged: a drag in progress takes Escape itself.
 */
export const useCancelSelectionOnEscape = (isEnabled: boolean, onCancel: () => void): void => {
  const cancel = useEffectEvent(onCancel);

  useEffect(() => {
    if (!isEnabled) return undefined;
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key !== 'Escape' || event.defaultPrevented) return;
      if (!document.activeElement?.closest('[data-dnd-context]')) return;
      cancel();
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [isEnabled]);
};
